import moment from 'moment'
import { useEffect, useState } from 'react'
import pmsApi from 'services/api/pms'

import ConfirmationDialog from '../../../components/ReusableComponents/ConfirmationDialog/index'
import styles from './EditPmsEmailsDialog.module.scss'
import EmailLogsDialog from './EmailLogsDialog/EmailLogsDialog'
import MoveLogsByEmailDialog from './MoveDialog/MoveDialog'

const EditPmsEmailsDialog = ({ onClose, email }) => {
  const [seeLogsDialogEmail, setSeeLogsDialogEmail] = useState()
  const [emailSummary, setSelectedEmailSummary] = useState()
  const [data, setData] = useState([])

  useEffect(() => {
    pmsApi
      .getPmsEmailSummary()
      .then(res => {
        setData(res)
      })
      .catch(err => {
        console.error(err)
      })
  }, [])

  useEffect(() => {
    if (data && email) {
      const emailSummary = data.find(row => row.email === email)
      setSelectedEmailSummary(emailSummary)
    }
  }, [data, email])

  return (
    <>
      <ConfirmationDialog
        title="Manage emails"
        theme="blacklist"
        onClose={onClose}
        maxWidth={800}
        hasConfirmButton={false}
      >
        <div className={styles.container}>
          <div className={styles.titleRow}>
            <div className={styles.emailCol}>Email Address</div>
            <div className={styles.lastRecordCol}>Last Record</div>
            <div className={styles.recordCountCol}>Records</div>
          </div>

          {data.map((row, index) => (
            <div key={index} className={styles.dataRow}>
              <div className={styles.emailCol}>{row.email}</div>
              <div className={styles.lastRecordCol}>
                {row.LastUploadOn
                  ? moment(row.lastUploadOn).format('MMM DD yyyy, hh:mm A')
                  : 'Never'}
              </div>
              <div className={styles.recordCountCol}>{row.numberOfLogs}</div>
              <div
                className={styles.seeAllLogCol}
                onClick={() => setSeeLogsDialogEmail(row.email)}
              >
                See all logs
              </div>
              <div
                className={styles.moveCol}
                onClick={() => setSelectedEmailSummary(row)}
              >
                Move to another hotel
              </div>
            </div>
          ))}
        </div>
      </ConfirmationDialog>

      {!!emailSummary && (
        <MoveLogsByEmailDialog
          emailSummary={emailSummary}
          onClose={() => setSelectedEmailSummary(undefined)}
        />
      )}

      {!!seeLogsDialogEmail && (
        <EmailLogsDialog
          email={seeLogsDialogEmail}
          onClose={onClose}
          onBack={() => setSeeLogsDialogEmail(undefined)}
        />
      )}
    </>
  )
}

export default EditPmsEmailsDialog
